module.exports = __webpack_public_path__ + "static/media/bg-assine.b20fcea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lps/bg-assine.png
// module id = 1010
// module chunks = 0